import { PW_LINK_SELECTOR } from 'utilities/consts/variable-types.js';

export const ComponentFakeLink = ({
  children,
  onClickCB,
  classes,
}: {
  onClickCB?: (e: React.MouseEvent<Element, MouseEvent>) => void;
  children: JSX.Element;
  classes?: string;
}) => {
  if (onClickCB) {
    return (
      <span onClick={onClickCB} className={`fake-link u-linkClean ${classes}`} data-testid={PW_LINK_SELECTOR}>
        {children}
      </span>
    );
  }
  return children;
};
